module.exports = (string, dict) ->
  result = string
  for token, value of dict
    result = result.replace('%{' + token + '}', value)
  result
